/** --------------------------------------------------------------------------------------------------------------------
 * responsive view Container, try to be like Bootstrap
 */

import React from 'react';

import './index.css';

type Props = {
  children: React.ReactNode;

  id       ?: string ;
  fluid    ?: boolean;
  style    ?: React.CSSProperties;
  className?: string ;
};

const Container = (props: Props) => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const containerClass: 'responsive-view-container-fluid' | 'responsive-view-container' =
    props?.fluid ? 'responsive-view-container-fluid' : 'responsive-view-container';

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================


  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <section
      id={props?.id}
      style={props?.style}
      className={`${containerClass} ${props?.className || ''}`}
    >
      {props?.children}
    </section>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
};

export default Container;
